import axios from 'axios'
import { getErrorMessage } from './getErrorMessage'

// Function to wrap FileReader in a promise
const readBlobAsText = (blob: Blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.addEventListener('error', reject)
    reader.readAsText(blob)
  })

export const getErrorMessageFromPossibleBlob = async (
  error: unknown,
  handleUnknownError = (_e: unknown) => {},
) => {
  if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
    // Read the error Blob as text
    const errorText = (await readBlobAsText(error.response?.data || new Blob())) as string
    const errorJson = JSON.parse(errorText)

    return errorJson.error
  }

  return getErrorMessage(error, handleUnknownError)
}
